var _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.9797 48.0969L75.2245 36.6899C75.1474 36.1884 74.8933 35.7309 74.5082 35.4004C74.1231 35.0699 73.6325 34.8881 73.125 34.8879C61.5076 34.8879 55.5534 29.1844 55.5024 29.1356C55.1042 28.7398 54.5656 28.5176 54.0042 28.5176C53.4428 28.5176 52.9043 28.7398 52.5061 29.1356C52.4466 29.1844 46.4924 34.8879 34.875 34.8879C34.3675 34.8881 33.8769 35.0699 33.4918 35.4004C33.1067 35.7309 32.8526 36.1884 32.7755 36.6899L31.0202 48.0969C30.233 53.2787 31.057 58.5772 33.3809 63.2751C35.7047 67.973 39.4161 71.8433 44.0125 74.3619L52.98 79.2494C53.2922 79.4198 53.6422 79.5091 53.9979 79.5091C54.3535 79.5091 54.7035 79.4198 55.0157 79.2494L63.9832 74.3619C68.5804 71.8439 72.2926 67.9738 74.6173 63.2759C76.9419 58.578 77.7666 53.2791 76.9797 48.0969ZM61.9517 70.6219L54 74.9676L46.0482 70.6304C42.2163 68.5327 39.1215 65.3081 37.1831 61.3932C35.2446 57.4782 34.5561 53.0622 35.2107 48.7429L36.6982 39.0933C42.9026 38.9544 48.9253 36.9727 54 33.4004C59.0726 36.9723 65.093 38.9546 71.2954 39.0954L72.7829 48.7429C73.4381 53.0615 72.7505 57.4771 70.8132 61.3919C68.8759 65.3068 65.7825 68.5318 61.9517 70.6304V70.6219Z",
    fill: "#09D674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9976 46.1356L49.75 57.3832L47.0024 54.6356C46.8063 54.4326 46.5719 54.2707 46.3126 54.1593C46.0533 54.048 45.7745 53.9894 45.4923 53.9869C45.2102 53.9844 44.9304 54.0382 44.6692 54.1451C44.4081 54.2519 44.1708 54.4097 43.9713 54.6092C43.7718 54.8087 43.614 55.046 43.5071 55.3072C43.4003 55.5683 43.3465 55.8481 43.349 56.1303C43.3514 56.4124 43.41 56.6913 43.5214 56.9505C43.6328 57.2098 43.7947 57.4443 43.9976 57.6403L48.2476 61.8903C48.6461 62.2887 49.1865 62.5125 49.75 62.5125C50.3135 62.5125 50.8539 62.2887 51.2524 61.8903L64.0024 49.1403C64.3895 48.7395 64.6036 48.2028 64.5988 47.6456C64.594 47.0884 64.3705 46.5554 63.9765 46.1614C63.5825 45.7675 63.0495 45.544 62.4923 45.5391C61.9352 45.5343 61.3984 45.7485 60.9976 46.1356Z",
    fill: "#09D674"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54.0129,
    r: 51.8059,
    stroke: "#09D674",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white",
    transform: "translate(28.5 28.5129)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success .e997b52e0ec50f1c1df691f1de15f963.svg";
export { ForwardRef as ReactComponent };